import React, { useState } from 'react';
import Navbar from "../components/navbar"; // Ensure this path is correct
import PageHeader from "./PageHeader";      // Ensure this path is correct
import Footer from "../components/Footer";  // Ensure this path is correct
import CTAButton from "../components/sticky-button"; // Ensure this path is correct
import './NispPolicy.css';

const NispPolicy = () => {
    const [activeTab, setActiveTab] = useState('introduction');

    const committeeMembers = [
        {
            sr: 1,
            name: "Dr. Pravin Gundalwar",
            designation: "Director, TIMSCDR",
            position: "Chairperson"
        },
        {
            sr: 2,
            name: "Prof. Sonu Gupta",
            designation: "Dy. Director, TIMSCDR",
            position: "Member"
        },
        {
            sr: 3,
            name: "Ms. Shweta Waghmare",
            designation: "Asst. Professor",
            position: "Co-Ordinator"
        },
        {
            sr: 4,
            name: "Dr. Suresh Shan",
            designation: "Global Technology Powered India (Author Researcher Speaker Simplify RuralTech.CySec) BFSI NBFC Enterprise Architect Creative Innovator",
            position: "Member"
        },
        {
            sr: 5,
            name: "Mr. Ashish Garde",
            designation: "Director, MAGIC (Marathwada Accelerator for Growth & Incubation Council)",
            position: "Member"
        },
        {
            sr: 6,
            name: "Mr. Nikunj Jakhotia",
            designation: "Accenture Alumni TIMSCDR",
            position: "Member"
        },
        {
            sr: 7,
            name: "Mr. Shirshendu Maitra",
            designation: "Asst. Professor",
            position: "Member"
        },
        {
            sr: 8,
            name: "Ms. Rashmi Vipat",
            designation: "Asst. Professor",
            position: "Member"
        },
        {
            sr: 9,
            name: "Ms. Alifiya",
            designation: "Asst. Professor",
            position: "Member"
        }
    ];
    return (
        <>
            <Navbar />
            <CTAButton />

            <div className="tsp-page-wrapper">
                <PageHeader
                    title="NISP Policy"
                    crumbs={[{ label: 'Home', href: '/' }, { label: 'NISP Policy' }]}
                />

                <main className="tsp-container tsp-main-grid">
                    {/* Sidebar */}
                    <aside className="tsp-sidebar">
                        <div className="tsp-download-card">
                            {/* <div className="tsp-card-img-placeholder">
                                <img src="/images/startup-illustration.jpg" alt="Innovation" />
                            </div> */}
                            <h3>TIMSCDR Startup Policy</h3>
                            <p>Empowering the next generation of entrepreneurs with guidance, infrastructure, and support.</p>
                            <button className="tsp-btn-primary" onClick={() => window.open('/pdf/about/NISP-Policy-updated-Nov-2025.pdf')}>
                                <img
                                    src="/images/icons/download.svg"
                                    alt="PDF Icon"
                                    className="tsp-btn-icon"
                                />
                                Download Policy PDF
                            </button>
                        </div>

                        <div className="tsp-toc-card">
                            <div className="tsp-toc-header">Table of Contents</div>
                            <nav className="tsp-toc-nav">
                                {[
                                    { id: 'introduction', label: 'Introduction & Committee' },
                                    { id: 'strategies', label: 'Strategies & Governance' },
                                    { id: 'infrastructure', label: 'Infrastructure' },
                                    { id: 'nurturing', label: 'Nurturing Startups' },
                                    { id: 'ownership', label: 'Product Ownership' },
                                    { id: 'incentives', label: 'HR & Incentives' },
                                    { id: 'pipeline', label: 'Innovation Pipeline' },
                                    { id: 'norms', label: 'Norms for Faculty Startups' },
                                    { id: 'pedagogy', label: 'Pedagogy & Learning' },
                                    { id: 'collaboration', label: 'Collaboration & Co-creation' },
                                    { id: 'impact', label: 'Impact Assessment' }
                                ].map(item => (
                                    <button
                                        key={item.id}
                                        className={`tsp-toc-link ${activeTab === item.id ? 'is-active' : ''}`}
                                        onClick={() => setActiveTab(item.id)}
                                    >
                                        {item.label}
                                    </button>
                                ))}
                            </nav>
                        </div>
                    </aside>

                    {/* Content Area */}
                    <section className="tsp-content-area">
                        {activeTab === 'introduction' && (
                            <div className="tsp-tab-pane">
                                <div className="tsp-section-title">National Innovation and Startup Policy (NISP) 2019</div>
                                <p className="tsp-paragraph">
                                    The 'National Innovation and Startup Policy (NISP) 2019' is a guiding framework to envision an educational system oriented towards start-ups and entrepreneurship opportunities for student and faculties.
                                    The guidelines provide ways to Indian HEIs for developing entrepreneurial agenda, managing Intellectual Property Rights (IPR) ownership, technology licensing and equity sharing in Startups or enterprises established by faculty and students.
                                </p>

                                <p className="tsp-paragraph">
                                    On the basis of NISP guidelines TIMSCDR constituted a committee to formulate detailed guidelines for various aspects related to innovation, Startup and entrepreneurship management.
                                    The Institution Innovation and Startup Committee at TIMSCDR comprising of people associated with delivering incubation and pre-incubation services and facilities, alumni, innovators, entrepreneurs, startup founders etc.
                                    The committee consists of the following members:
                                </p>

                       <div className="table-container">
    {/* If you want a title above the table that matches your CSS */}
  
    
    <table className="responsive-table">
        <thead>
            <tr>
                <th>SR. NO.</th>
                <th>NAME</th>
                <th>DESIGNATION</th>
                <th>POSITION</th>
            </tr>
        </thead>
        <tbody>
            {committeeMembers.map((m) => (
                <tr key={m.sr}>
                    <td>{m.sr}</td>
                    <td >{m.name}</td>
                    <td>{m.designation}</td>
                    <td>{m.position}</td>
                </tr>
            ))}
        </tbody>
    </table>
</div>

                                <div className="tsp-policy-overview">
                                    <h3 className="tsp-subsection-title">Policy Focus Areas:</h3>
                                    <ul className="tsp-list">
                                        <li>Strategies and Governance</li>
                                        <li>Startups Enabling Institutional Infrastructure</li>
                                        <li>Nurturing Innovations and Startups</li>
                                        <li>Product Ownership Rights for Technologies Developed at Institute</li>
                                        <li>Organizational Capacity, Human Resources and Incentives</li>
                                        <li>Creating Innovation Pipeline and Pathways for Entrepreneurs at Institute Level</li>
                                        <li>Norms for Faculty Startups</li>
                                        <li>Pedagogy and Learning Interventions for Entrepreneurship Development</li>
                                        <li>Collaboration, Co-creation, Business Relationships and Knowledge Exchange</li>
                                        <li>Entrepreneurial Impact Assessment</li>
                                    </ul>
                                </div>
                                <div className="tsp-next-link" onClick={() => setActiveTab('strategies')}>
                                    Next: Strategies & Governance <span>&rarr;</span>
                                </div>
                            </div>
                        )}

                        {activeTab === 'strategies' && (
                            <div className="tsp-tab-pane">
                                <div className="tsp-section-title">Strategies and Governance</div>

                                <ul className="tsp-list">
                                    <li>
                                        Entrepreneurship promotion and development should be one of the major dimensions of the HEIs strategy.
                                        To facilitate development of an entrepreneurial ecosystem in the organization, specific objectives and associated performance indicators should be defined for assessment.
                                    </li>
                                    <li>
                                        Implementation of entrepreneurial vision at the institute should be achieved through mission statements rather than stringent control system.
                                        The entrepreneurial agenda should be the responsibility of a senior person at the level of dean/ director/ equivalent position to bring in required commitment.
                                        This person should be very carefully chosen from someone who understands the industry and business.
                                    </li>
                                    <li>
                                        Resource mobilisation plan should be worked out at the institute for supporting pre-incubation, incubation infrastructure and facilities.
                                        A sustainable financial strategy should be defined in order to reduce the organizational constraints.
                                    </li>
                                    <li>
                                        For expediting the decision making, hierarchical barriers should be minimized and individual autonomy and ownership of initiatives should be promoted.
                                    </li>
                                    <li>
                                        Importance of innovation and entrepreneurial agenda should be known across the institute and should be promoted at institutional programs such as conferences, convocations, and workshops.
                                    </li>
                                    <li>
                                        Student and faculty startup Policy and action plan should be formulated at university level with well-defined short-term and long-term goals.
                                    </li>
                                    <li>
                                        Institute should develop and implement I & E strategy and policy for the entire institute to integrate entrepreneurial activities across various departments and break silos.
                                    </li>
                                    <li>
                                        Product to market strategy for startups should be developed by the institute on a case-to-case basis.
                                    </li>
                                    <li>
                                        Development of entrepreneurship culture should not be limited within the boundaries of the institution.
                                    </li>
                                </ul>

                                <div className="tsp-next-link" onClick={() => setActiveTab('infrastructure')}>
                                    Next: Infrastructure <span>&rarr;</span>
                                </div>
                            </div>
                        )}

                        {activeTab === 'infrastructure' && (
                            <div className="tsp-tab-pane">
                                <div className="tsp-section-title">Startups Enabling Institutional Infrastructure</div>

                                <ul className="tsp-list">
                                    <li>
                                        Creation of pre-incubation and incubation facilities for nurturing innovations and startups in HEIs institutions should be undertaken.
                                        Incubation and Innovation need to be organically interlinked; without innovation, new enterprises are unlikely to succeed.
                                        The goal of the effort should be to link INNOVATION to ENTREPRISES to FINANCIAL SUCCESS.
                                    </li>
                                    <li>
                                        All HEIs are advised to create facilities within their institution for supporting pre-incubation (e.g. IICs as per the guidelines by MHRD’s Innovation Cell, EDC, IEDC, New-Gen IEDC, Startup Cell, Student Clubs, etc.) and Incubation/acceleration by mobilizing resources from internal and external sources.
                                    </li>
                                    <li>
                                        This Pre-Incubation/Incubation facility should be accessible 24×7 to students, staff and faculty of all disciplines and departments across the institution.
                                    </li>
                                    <li>
                                        It is recommended that the ‘Incubation cum Technology Commercialization Unit’ (ITCU) should be a separate entity, preferably registered under Section-8 of Company Act 2013 or as a ‘Society’ with an independent governance structure.
                                        This allows more freedom in decision making with less administrative hassles and better accountability towards investors.
                                    </li>
                                    <li>
                                        HEIs may offer mentoring and other relevant services through units in return for fees, equity sharing, and (or) zero payment basis.
                                        Modalities regarding Equity Sharing will depend upon the nature of services offered by these units.
                                    </li>
                                </ul>

                                <div className="tsp-next-link" onClick={() => setActiveTab('nurturing')}>
                                    Next: Nurturing Startups <span>&rarr;</span>
                                </div>
                            </div>
                        )}
                        {activeTab === 'nurturing' && (
                            <div className="tsp-tab-pane">
                                <div className="tsp-content-wrap">
                                    <div className="tsp-section-title">Nurturing Innovations and Startups</div>

                                    <ul className="tsp-list">
                                        <li>
                                            HEIs are expected to establish processes for easy creation and nurturing of Start-ups by students (UG, PG, Ph.D.), staff, faculty, alumni, and potential applicants from outside the institutions.
                                        </li>
                                        <li>
                                            Students pursuing entrepreneurial ventures should be allowed to use the institute's address to register their company with due permission.
                                        </li>
                                        <li>
                                            Student entrepreneurs should be allowed to sit for examinations even if their attendance is less than the minimum permissible percentage, with due permission from the institute.
                                        </li>
                                        <li>
                                            HEIs should allow students to take a semester/year break to work on their start-ups and re-join academics. Student entrepreneurs may earn academic credits for their efforts based on review committee progress.
                                        </li>
                                        <li>
                                            The institute should explore provision of accommodation to entrepreneurs within the campus for a specific period.
                                        </li>
                                        <li>
                                            Faculty and staff may take off for a semester/year as sabbatical or unpaid leave to work on start-ups while preserving their seniority and academic benefits.
                                        </li>
                                        <li>
                                            Institute will facilitate technology development by allowing the use of institute infrastructure and facilities as per the entrepreneur's choice.
                                        </li>
                                        <li>
                                            In return for services, the institute may take 2% to 9.5% equity in the startup based on the support provided and brand used. A limit of 9.5% is suggested to ensure the institute has no legal liability.
                                        </li>
                                        <li>
                                            Participation in start-up activities and mentoring should be considered a legitimate activity for faculty during annual performance evaluations and promotions.
                                        </li>
                                        <li>
                                            The institute must ensure that at no stage does any liability accrue to it because of any activity of any startup.
                                        </li>
                                    </ul>
                                </div>

                                <div className="tsp-next-link" onClick={() => setActiveTab('ownership')}>
                                    Next: Product Ownership <span>&rarr;</span>
                                </div>
                            </div>
                        )}

                        {activeTab === 'ownership' && (
                            <div className="tsp-tab-pane">
                                <div className="tsp-content-wrap">
                                    <div className="tsp-section-title">Product Ownership Rights for Technologies Developed at Institute</div>

                                    <ul className="tsp-list">
                                        <li>
                                            When institute facilities or funds are used substantially, or when IPR is developed as part of curriculum/academic activity, IPR is to be jointly owned by inventors and the institute.
                                        </li>
                                        <li>
                                            If product/IPR is developed without using institute facilities, outside office hours (for staff), or not as part of a student's curriculum, the IPR is entirely owned by inventors. In this case, inventors may license the technology as they deem fit.
                                        </li>
                                        <li>
                                            In case of ownership disputes, a five-member committee comprising faculty with IPR experience, industry experts/alumni, and a legal advisor will examine and settle the issue.
                                        </li>
                                        <li>
                                            The Institute IPR cell or incubation center acts only as a coordinator and facilitator. They have no say in how inventions are carried out or licensed, though a committee may examine IPR worthiness if the institute is paying for patent filing.
                                        </li>
                                        <li>
                                            All decision-making bodies regarding incubation, IPR, and technology-licensing will consist solely of faculty and experts excelled in technology translation. Other administrative heads will have no say in these specific technical decisions.
                                        </li>
                                        <li>
                                            Interdisciplinary research and publication on startup and entrepreneurship should be actively promoted by the institution.
                                        </li>
                                    </ul>
                                </div>

                                <div className="tsp-next-link" onClick={() => setActiveTab('incentives')}>
                                    Next: HR & Incentives <span>&rarr;</span>
                                </div>
                            </div>
                        )}

                        {activeTab === 'incentives' && (
                            <div className="tsp-tab-pane">
                                <div className="tsp-content-wrap">
                                    <div className="tsp-section-title">Organizational Capacity, Human Resources and Incentives</div>
                                    <ul className="tsp-list">
                                        <li>Institute should recruit staff with strong innovation and entrepreneurial/industrial experience, behavior, and attitude to foster an I&E culture.</li>
                                        <li>Faculty and departments must work in coherence, strengthening cross-departmental linkages through shared faculty and research to maximize resource utilization.</li>
                                        <li>External subject matter experts and alumni should be engaged periodically for strategic advice and specialized skills.</li>
                                        <li>Faculty and staff should be encouraged to take courses on innovation, entrepreneurship management, and venture development.</li>
                                        <li>The institute should develop academic and non-academic incentive mechanisms to attract and retain stakeholders who support the entrepreneurship agenda.</li>
                                    </ul>
                                </div>
                                <div className="tsp-next-link" onClick={() => setActiveTab('pipeline')}>
                                    Next: Innovation Pipeline <span>&rarr;</span>
                                </div>
                            </div>
                        )}

                        {activeTab === 'pipeline' && (
                            <div className="tsp-tab-pane">
                                <div className="tsp-content-wrap">
                                    <div className="tsp-section-title">Creating Innovation Pipeline and Pathways for Entrepreneurs</div>
                                    <ul className="tsp-list">
                                        <li>Mechanisms should be devised to ensure maximum student exposure to innovation and pre-incubation from ideation to market.</li>
                                        <li>The institute should link startups with the wider ecosystem and connect students with real-life entrepreneurs to increase the probability of success.</li>
                                        <li>Establishment of Institution’s Innovation Councils (IICs) as per MHRD guidelines is essential to scout and reward student innovations.</li>
                                        <li>Access to financing must be opened for potential entrepreneurs to strengthen the innovation funnel.</li>
                                        <li>A "Ready Reckoner" Innovation Tool Kit should be maintained on the institute’s homepage to answer queries from innovators.</li>
                                    </ul>
                                </div>
                                <div className="tsp-next-link" onClick={() => setActiveTab('norms')}>
                                    Next: Faculty Norms <span>&rarr;</span>
                                </div>
                            </div>
                        )}

                        {activeTab === 'norms' && (
                            <div className="tsp-tab-pane">
                                <div className="tsp-content-wrap">
                                    <div className="tsp-section-title">Norms for Faculty Startups</div>
                                    <ul className="tsp-list">
                                        <li>Faculty startups should only utilize technologies that originate from within the same institute.</li>
                                        <li>Faculty holding executive positions in a startup for over three months must go on sabbatical or leave without pay.</li>
                                        <li>A clear separation must be maintained between ongoing institute research and work conducted at the startup.</li>
                                        <li>Faculty must not accept gifts from the startup or involve institute research staff in startup activities and vice-versa.</li>
                                        <li>Human subject research in a startup requires clearance from the institution's ethics committee.</li>
                                    </ul>
                                </div>
                                <div className="tsp-next-link" onClick={() => setActiveTab('pedagogy')}>
                                    Next: Pedagogy <span>&rarr;</span>
                                </div>
                            </div>
                        )}

                        {activeTab === 'pedagogy' && (
                            <div className="tsp-tab-pane">
                                <div className="tsp-content-wrap">
                                    <div className="tsp-section-title">Pedagogy and Learning Interventions</div>
                                    <ul className="tsp-list">
                                        <li>Adopt a diversified approach including cross-disciplinary learning, mentors, and labs instead of traditional lectures.</li>
                                        <li>Impart entrepreneurship education through elective, short-term, or long-term courses with validated learning outcomes.</li>
                                        <li>Ensure student projects are based on real-life challenges and constantly update learning interventions to match industry trends.</li>
                                    </ul>
                                </div>
                                <div className="tsp-next-link" onClick={() => setActiveTab('collaboration')}>
                                    Next: Collaboration <span>&rarr;</span>
                                </div>
                            </div>
                        )}

                        {activeTab === 'collaboration' && (
                            <div className="tsp-tab-pane">
                                <div className="tsp-content-wrap">
                                    <div className="tsp-section-title">Collaboration, Co-creation and Business Relationships</div>
                                    <ul className="tsp-list">
                                        <li>Prioritize engagement with MSMEs, social enterprises, alumni, and professional bodies to co-design entrepreneurship programs.</li>
                                        <li>Develop clear policy guidelines for managing relationships with private industries and external stakeholders.</li>
                                        <li>Institutional policy must provide support mechanisms for creating and coordinating knowledge exchange partnerships.</li>
                                    </ul>
                                </div>
                                <div className="tsp-next-link" onClick={() => setActiveTab('impact')}>
                                    Next: Impact Assessment <span>&rarr;</span>
                                </div>
                            </div>
                        )}

                        {activeTab === 'impact' && (
                            <div className="tsp-tab-pane">
                                <div className="tsp-content-wrap">
                                    <div className="tsp-section-title">Entrepreneurial Impact Assessment</div>
                                    <ul className="tsp-list">
                                        <li>Regularly perform impact assessments of incubation and education initiatives using well-defined evaluation parameters.</li>
                                        <li>Use impact information actively while reviewing and developing the overall entrepreneurial strategy.</li>
                                        <li>Success must be measured in terms of sustainable social, financial, and technological impact, with commercial success being the primary long-run measure.</li>
                                    </ul>
                                </div>
                                <div className="tsp-next-link" onClick={() => setActiveTab('introduction')}>
                                    Back to Start <span>&rarr;</span>
                                </div>
                            </div>
                        )}
                        {/* Additional Tab Panes go here following the same pattern */}
                    </section>
                </main>


            </div>
            <Footer />
        </>
    );
};

export default NispPolicy;